import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const distinctAsync = (source, comparer) => {
    const generator = async () => {
        const distinctElements = [];
        outerLoop: for (const item of await source.toArray()) {
            for (const distinctElement of distinctElements) {
                const found = await comparer(distinctElement, item);
                if (found) {
                    continue outerLoop;
                }
            }
            distinctElements.push(item);
        }
        return distinctElements;
    };
    return new BasicParallelEnumerable({
        generator,
        type: 0,
    });
};
